/**
 * Funções de validação para Nova OS
 * Migrado de App.js para estrutura modular
 */

import { isTipoAllowedForDefeito, TIPO_OS_VALUE_LABELS } from './defeitoTipoRules';

/** Solicitante, contato, defeito e observação (sem regra de tipo de OS). */
export const validateBaseOsFields = (solicitante, contato, selectedDefeito, defeitoObservacao) => {
  const isSolicitanteValid = solicitante && solicitante.trim().length >= 3;
  const isContatoValid = contato && contato.trim().length >= 10;
  const isDefeitoValid = selectedDefeito && defeitoObservacao && defeitoObservacao.trim().length >= 15;
  return isSolicitanteValid && isContatoValid && isDefeitoValid;
};

/**
 * Valida campos obrigatórios da OS
 * @param {string} solicitante - Nome do solicitante
 * @param {string} contato - Número de contato
 * @param {object} selectedDefeito - Defeito selecionado
 * @param {string} defeitoObservacao - Observação do defeito
 * @param {object} [extras] - { requerTipoOsPorDefeito, tipoOsValue }
 * @returns {boolean}
 */
export const validateRequiredFields = (solicitante, contato, selectedDefeito, defeitoObservacao, extras) => {
  if (!validateBaseOsFields(solicitante, contato, selectedDefeito, defeitoObservacao)) return false;
  if (extras && extras.requerTipoOsPorDefeito && selectedDefeito) {
    const t = extras.tipoOsValue;
    if (!t || !isTipoAllowedForDefeito(selectedDefeito, t)) return false;
  }
  return true;
};

/**
 * Valida campos obrigatórios da OS e retorna mensagens de erro detalhadas
 * @param {string} solicitante - Nome do solicitante
 * @param {string} contato - Número de contato
 * @param {object} selectedDefeito - Defeito selecionado
 * @param {string} defeitoObservacao - Observação do defeito
 * @param {object} [extras] - { requerTipoOsPorDefeito, tipoOsValue }
 * @returns {object} { isValid: boolean, errors: string[] }
 */
export const validateRequiredFieldsWithErrors = (solicitante, contato, selectedDefeito, defeitoObservacao, extras) => {
  const errors = [];

  if (!solicitante || solicitante.trim().length === 0) {
    errors.push('- SOLICITANTE: Campo obrigatório');
  } else if (solicitante.trim().length < 3) {
    errors.push('- SOLICITANTE: Deve conter no mínimo 3 caracteres');
  }

  if (!contato || contato.trim().length === 0) {
    errors.push('- CONTATO: Campo obrigatório');
  } else if (contato.trim().length < 10) {
    errors.push('- CONTATO: Deve conter no mínimo 10 caracteres');
  }

  if (!selectedDefeito) {
    errors.push('- DEFEITO: Selecione um defeito');
  }

  if (!defeitoObservacao || defeitoObservacao.trim().length === 0) {
    errors.push('- OBSERVAÇÃO DO DEFEITO: Campo obrigatório');
  } else if (defeitoObservacao.trim().length < 15) {
    errors.push('- OBSERVAÇÃO DO DEFEITO: Deve conter no mínimo 15 caracteres');
  }

  if (extras && extras.requerTipoOsPorDefeito && selectedDefeito) {
    const t = extras.tipoOsValue;
    if (!t) {
      errors.push('- TIPO DE OS: Selecione um tipo permitido para este defeito');
    } else if (!isTipoAllowedForDefeito(selectedDefeito, t)) {
      const lb = TIPO_OS_VALUE_LABELS[t] || t;
      errors.push(`- TIPO DE OS: "${lb}" não é permitido para este defeito`);
    }
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

/**
 * Valida formato de e-mail
 * @param {string} email - E-mail a ser validado
 * @returns {boolean}
 */
export const validateEmail = (email) => {
  if (!email || email.trim().length === 0) {
    return true; // E-mail é opcional
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

